import type { Skill, SkillStore } from '../../ports/skills'
import type { Transport } from './transport'

export class HttpSkillStore implements SkillStore {
  constructor(private readonly t: Transport) {}

  list(): Promise<Skill[]> {
    return this.t.json<Skill[]>('GET', '/v1/skills')
  }

  setEnabled(id: string, enabled: boolean): Promise<Skill> {
    return this.t.json<Skill>('PATCH', `/v1/skills/${id}`, { body: { enabled } })
  }

  create(input: Omit<Skill, 'id' | 'source'>): Promise<Skill> {
    return this.t.json<Skill>('POST', '/v1/skills', { body: input })
  }

  update(id: string, patch: Partial<Skill>): Promise<Skill> {
    return this.t.json<Skill>('PATCH', `/v1/skills/${id}`, { body: patch })
  }

  async delete(id: string): Promise<void> {
    await this.t.request('DELETE', `/v1/skills/${id}`)
  }
}
